/**
 * Profile-new.tsx
 * New-page entry point for Profile redesign.
 * This wrapper reuses the existing Profile logic until Figma-specific UI is applied.
 */

import React from 'react';
import ProfilePage from './Profile';

/**
 * ProfileNew
 * Named page component for the new Profile route.
 */
function ProfileNew(): React.ReactElement
{
    return <ProfilePage />;
}

export default ProfileNew;
